import React from 'react';

const PortfolioPostMeta = () => {
    return (
        <div className="infocolors-hero-info-line" data-stagger-appear="fade-up" data-delay="200" data-stager-delay="100" data-unload="fade-up">
            <div className="infocolors-meta">
                Client: <span>Curology</span>
            </div>
            <div className="infocolors-meta">
                Service: <span>Branding</span>
            </div>
            <div className="infocolors-meta">
                Date: <span>October '2023</span>
            </div>
        </div>
    );
};

export default PortfolioPostMeta;
